import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import Icon from 'components/icon/Icon';
import { FILTER_TYPE_SINGLE_CHECKBOX } from '../../constants/filter-types';

const renderLabel = (filter, val) => {
    return filter.type === FILTER_TYPE_SINGLE_CHECKBOX ? filter.label : val;
};

const ActiveFilters = ({ activeFiltersLabel, activeFilters, toggleFilters, resetFilters }) => {
    return (
        <ReactCSSTransitionGroup
            component = 'div'
            className = 'active-filters'
            transitionName = 'fade-in-out'
            transitionEnterTimeout = {200}
            transitionLeaveTimeout = {200}>

            <div className="active-filter-heading"><small>{activeFiltersLabel}</small></div>

            {activeFilters.map((filter, outerIndex) => {
                return (
                    filter.values.map((value, index) => {
                        return (
                            <div key={`${outerIndex}-${index}`} className='active-filter-item' onClick={() => toggleFilters(filter, value, true)} >
                                <Icon glyph='cross' />
                                <span>{renderLabel(filter, value)}</span>
                            </div>
                        );
                    })
                );
            })}

            <div className="active-filter-reset"><small className='btn-text' onClick={resetFilters}>Reset Filters</small></div>

        </ReactCSSTransitionGroup>
    );
};

ActiveFilters.propTypes = {
    activeFiltersLabel: React.PropTypes.string.isRequired,
    activeFilters: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    resetFilters: React.PropTypes.func.isRequired,
    toggleFilters: React.PropTypes.func.isRequired
};

export default ActiveFilters;



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/filters/active-filters/ActiveFilters.jsx
 **/